import React, { useState, useEffect } from 'react'
import {
  makeStyles,
  createStyles,
  useTheme,
  useMediaQuery,
  Box,
  Button,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  FormHelperText,
  CircularProgress,
  InputLabel,
  Divider,
  Accordion,
  AccordionSummary,
  Radio,
} from '@material-ui/core'
// import { scroller } from 'react-scroll'
import { useTranslation, Trans } from 'react-i18next'
import { throttle } from 'lodash'
import { object as yObject, string as yString } from 'yup'
import { Formik } from 'formik'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import { addOrder, pay, getNoAppointmentTimes, getPrice } from 'src/store/slices/userSlice'
import { getUserInfo } from 'src/store/slices/authSlice'
import { PACKAGE_INFO, SERVICE_PHONE_02, ID_TYPES } from 'src/utils/constant'
import { encryptId } from 'src/utils'
// import UserInfoForm from 'src/mobile/components/UserInfoForm'
import { useCustomTranslation, useDateFnsLocale } from 'src/hooks'
// import TagManager from 'react-gtm-module'
import FocusError from 'src/mobile/components/FocusError'
import InfoWrapper from 'src/mobile/components/InfoWrapper'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
// import CallOutlinedIcon from '@material-ui/icons/CallOutlined'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined'
// import { ReactComponent as AddInfoIcon } from 'src/mobile/assets/icons/addInfo.svg'
// import { ERadio } from 'src/mobile/themes/components/ETextField'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'
// import EFullscreenDialog from 'src/mobile/themes/components/EFullscreenDialog'
import { QUIZ_LIST, QUIZ_ANSWER_OPTIONS } from 'src/mobile/utils/constant'
import InfoItem from 'src/mobile/components/Order/InfoItem'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import PersonInfo from 'src/mobile/components/PersonInfo'
import { addShippingInfo } from 'src/utils/trackingCode'
import translationHK from 'src/assets/locales/zh-HK/translation.json'

const useStyles = makeStyles((theme) =>
  createStyles({
    profileTitle: {
      maxWidth: 1300,
      margin: '0 auto',
      fontSize: 32,
      fontWeight: 600,
      borderBottom: '1px solid #E5E7EB',
      paddingBottom: theme.spacing(1),
    },
    heading: {
      fontSize: 14,

      fontWeight: 500,
    },
    secondaryHeading: {
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing(5),
    },
    accord: {
      boxShadow: 'none',
    },
    accordion: {
      padding: 0,
      position: 'relative',
      borderTop: '1px solid #E5E7EB',
      borderBottom: '1px solid #E5E7EB',
    },
    accordion3: {
      padding: 0,
      position: 'relative',
      borderBottom: '1px solid #E5E7EB',
    },
    accordion2: {
      padding: 0,
      position: 'relative',
      borderTop: '1px solid #E5E7EB',
    },
    content: {
      display: 'inline-block',
    },
    userInfoButton: {
      height: theme.spacing(4.5),
      fontSize: theme.typography.body1.fontSize,
    },
    radioGroup: {
      borderBottom: `1px solid ${theme.palette.grey[50]}`,
    },
    inputLabelFormControl: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      position: 'relative',
      fontSize: theme.typography.body1.fontSize,
      lineHeight: 1.5,
      fontWeight: 400,
      transform: `translate(0) scale(1)`,
    },
    asterisk: {
      lineHeight: 0.5,
      color: theme.palette.secondary.main,
    },
    FaqBtn: {
      position: 'absolute',
      right: theme.spacing(3),
      top: theme.spacing(27),
      borderRadius: 100,
      width: 100,
      fontSize: 14,
      fontWeight: 700,
      marginBottom: theme.spacing(2),
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
      },
    },
    paperAnchorBottom: {
      maxHeight: '90%',
      padding: theme.spacing(0),
    },
    formLabel: {
      display: 'inline-flex',
      color: theme.palette.text.primary,
      fontSize: 18,
      fontWeight: 500,
      lineHeight: '26px',
    },
    form: {
      height: '1000px !important',
    },
    titleTop: {
      height: '70px !important',
    },
    radio: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: theme.spacing(2),
      color: theme.palette.text.primary,
    },
    labelText: {
      fontSize: 18,
    },
    accordionDetails: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 16,
      justifyContent: 'space-between',
    },
    accordionDetails2: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: 0,
      justifyContent: 'space-between',
    },
    card: {
      borderRadius: 20,
      border: '1px solid #E5E7EB',
      padding: theme.spacing(2),
    },
    flexLayout: {
      maxWidth: 1300,
      margin: '0 auto',
      padding: theme.spacing(2),
    },
    expandIcon: {
      position: 'absolute',
      right: 175,
    },
  }),
)

const initialValues = {
  history: '',
  previous: '',
  current: '',
  smoker: '',
}

const AddOrder = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const { t, i18n } = useTranslation()
  const [tB] = useCustomTranslation()
  const { formatDate } = useDateFnsLocale()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { addOrderStatus, payStatus, noAppointmentTimesStatus } = useSelector((state) => state.user)
  const { userInfo } = useSelector((state) => state.auth)
  const { selectedDoctor } = useSelector((state) => state.testCenter)
  const [expanded, setExpand] = useState(false)
  const [hadCreateOrder, setHadCreateOrder] = useState(false)
  // const isAddOrder = useRouteMatch('/add-order')
  // const isAddOrderStep = useRouteMatch('/add-order/success/') || useRouteMatch('/add-order/paying/')

  useEffect(() => {
    dispatch(getUserInfo())
    dispatch(
      getPrice({
        testCenterId: selectedDoctor?.testCenterId,
        doctorId: selectedDoctor.doctorId,
        package: Number(selectedDoctor?.package),
      }),
    )
  }, [])

  useEffect(() => {
    if (selectedDoctor) {
      // TagManager.dataLayer({
      //   dataLayer: {
      //     ecommerce: null,
      //   },
      // })
      // TagManager.dataLayer({
      //   dataLayer: {
      //     event: 'checkout',
      //     ecommerce: {
      //       checkout: {
      //         actionField: { step: 1 },
      //         products: [
      //           {
      //             name: selectedDoctor[tB('name')] || '',
      //             id: `${selectedDoctor.id || ''}`,
      //             price: `${selectedDoctor?.price || ''}`,
      //             brand: selectedDoctor.testCenterName || '',
      //             category: selectedDoctor[tB('honoraryTitle')] || '',
      //             variant: selectedDoctor.appointmentTime || '',
      //             dimension1: selectedDoctor.appointmentDate || '',
      //             quantity: 1,
      //           },
      //         ],
      //       },
      //     },
      //   },
      // })
    } else {
      history.push('/')
    }
  }, [selectedDoctor])

  // const handleTriggerChange = () => setTriggerState((state) => !state)

  const quizSchema = yString().required(t('validation.cannot_be_empty', { field: '$t(glossary.options)' }))
  // const clickSubmitButton = () => {
  //   setDialogOpen(true)
  // }
  // const [formValues, setFormValues] = useState({
  //   englishName: '',
  //   idType: '',
  //   idNumber: '',
  //   gender: '',
  //   birthDate: '',
  //   chineseName: '',
  // })

  // const handleChangeForm = (event) => {
  //   setFormValues({
  //     ...formValues,
  //     [event.target.name]: event.target.value,
  //   })
  // }

  // const handleSubmitForm = (value) => {
  //   // event.preventDefault()
  //   console.log(value, 'formValues')
  //   return false
  // }

  const schema = yObject({
    history: quizSchema,
    previous: quizSchema,
    current: quizSchema,
    smoker: quizSchema,
  })

  const addTrackingCode = () => {
    const title = PACKAGE_INFO[Number(selectedDoctor?.package)].title
    const titleArr = title.split('.')
    const len = titleArr.length - 1
    let name
    let num = 0
    let obj = translationHK
    while (num <= len) {
      name = obj[titleArr[num]]
      obj = obj[titleArr[num]]
      num++
    }
    const ecommerce = {
      currency: selectedDoctor.currency,
      value: selectedDoctor.price,
      items: [
        {
          item_id: PACKAGE_INFO[Number(selectedDoctor?.package)].id,
          item_name: name,
          index: PACKAGE_INFO[Number(selectedDoctor?.package)].index,
          price: selectedDoctor.price,
          item_category: selectedDoctor.testCenterAddressHk,
          item_category2: selectedDoctor.appointmentDate,
          item_category3: selectedDoctor.appointmentTime,
          item_category4: selectedDoctor.nameHk,
        },
      ],
    }
    addShippingInfo(ecommerce)
  }

  const onClick = () => {
    if (!userInfo?.isCompleteInfo) {
      const form = document.getElementById('submit')
      form.click()
    }
    const form2 = document.getElementById('submit2')
    form2.click()
  }

  const productAbstract = () => {
    return (
      <Box className={isMobile ? {} : classes.card}>
        <Accordion className={classes.accord} expanded={expanded} onChange={() => setExpand(!expanded)}>
          <AccordionSummary
            aria-controls="panel1a-content"
            id="panel1a-header"
            classes={{
              root: !isMobile ? classes.accordion3 : expanded ? classes.accordion2 : classes.accordion,
              content: classes.content,
            }}
          >
            <Box display="flex" justifyContent="space-between">
              <Box className={classes.column} flexShrink="0" display="flex" alignItems="center">
                <Typography className={classes.heading}>
                  {expanded ? t('common.order_datail_hide') : t('common.order_datail')}
                </Typography>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Box>
              <Box>
                <Typography className={classes.secondaryHeading}>
                  <ENumberFormat
                    value={Number(selectedDoctor?.price)}
                    currency={selectedDoctor?.currency}
                    color="#111827"
                  />
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>{' '}
          <Box>
            <Box fontSize={18} fontWeight={700} mt={!isMobile && 2}>
              {t(PACKAGE_INFO[Number(selectedDoctor?.package)].title)}
            </Box>
            <Box mt={1}>
              <ENumberFormat
                fontSize={18}
                color="secondary.main"
                value={Number(selectedDoctor?.price)}
                currency={selectedDoctor?.currency}
              />
            </Box>
          </Box>
          <Box display="flex" alignItems="center" my={2}>
            <LocationOnOutlinedIcon variant="outline" style={{ fontSize: 24, marginRight: 4 }} />
            <Box component="span" fontSize={16} fontWeight={700}>
              {selectedDoctor?.[tB('testCenterName')]}
            </Box>
          </Box>{' '}
          <Box fontSize={14} ml={2.5} mb={2} color="#4B5563">
            {selectedDoctor?.[tB('testCenterAddress')]}
          </Box>
          <Divider style={{ background: '#E5E7EB' }} />
          {/* <Box display="flex" alignItems="center" my={1}>
                <CallOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
                <Box component="span" fontSize={14}>
                  {selectedDoctor?.phone}
                </Box>
              </Box>
              <Divider /> */}
          <Box display="flex" alignItems="center" my={2}>
            <DateRangeOutlinedIcon
              variant="outline"
              style={{ fontSize: isMobile ? 24 : 18, marginRight: 4 }}
            />
            <Box component="span" fontSize={isMobile ? 16 : 16} mr={4}>
              {formatDate(new Date(selectedDoctor?.appointmentDate))}
            </Box>
            <Divider orientation="vertical" flexItem style={{ background: '#E5E7EB' }} />
            <Box component="span" fontSize={14} mx={4} display="flex" alignItems="center">
              <AccessTimeIcon variant="outline" style={{ fontSize: isMobile ? 24 : 18, marginRight: 4 }} />
              <Box fontSize={isMobile ? 16 : 16}> {selectedDoctor?.appointmentTime}</Box>
            </Box>
          </Box>
          <Divider style={{ background: '#E5E7EB' }} />
          <Box display="flex" alignItems="center" my={2}>
            <PermContactCalendarOutlinedIcon
              variant="outline"
              style={{ fontSize: isMobile ? 24 : 18, marginRight: 4 }}
            />
            <Box component="span" fontSize={isMobile ? 16 : 16} fontWeight={700}>
              {selectedDoctor?.[tB('name')] || ''}
            </Box>
          </Box>
          <Divider style={{ background: '#E5E7EB' }} />
        </Accordion>
        <Box className={expanded ? classes.accordionDetails2 : classes.accordionDetails}>
          <Box className={classes.column} color="#4B5563">
            <Typography className={classes.heading}>{t('common.add_summary')}</Typography>
          </Box>
          <Box>
            <Typography className={classes.secondaryHeading}>
              <ENumberFormat
                value={Number(selectedDoctor?.price)}
                currency={selectedDoctor?.currency}
                color="#111827"
              />
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }

  const renderButton = (isSubmitting) => {
    return (
      <>
        <Button type="submit" id="submit2" style={{ display: 'none' }}>
          {t('faq.submit')}
        </Button>
        <Box width="100%" display={isMobile ? 'block' : 'flex'} justifyContent="flex-end">
          <Button
            fullWidth={isMobile}
            // type="submit"
            style={isMobile ? {} : { fontSize: '18px', fontWeight: 600, width: 150 }}
            size={isMobile ? 'medium' : 'large'}
            variant="contained"
            color="secondary"
            disabled={isSubmitting}
            onClick={onClick}
          >
            {addOrderStatus === 'pending' || payStatus === 'pending' ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              t('common.go_on')
            )}
          </Button>
        </Box>
      </>
    )
  }

  return (
    <Box>
      {selectedDoctor && (
        <>
          {' '}
          {/* <Divider /> */}
          <InfoWrapper title={isMobile ? t('common.fill_info') : null}>
            {isMobile ? (
              productAbstract()
            ) : (
              <Box className={classes.profileTitle}>{t('common.fill_info')}</Box>
            )}
          </InfoWrapper>
          <Box
            className={isMobile ? {} : classes.flexLayout}
            display={isMobile ? 'block' : 'flex'}
            justifyContent="center"
            mt={2}
          >
            <Box className={isMobile ? {} : classes.card} width={isMobile ? '100%' : '65%'}>
              <InfoWrapper titleVariant={isMobile ? 'h4' : 'h6'} title={t('common.test_info')}>
                {/* 用户信息缺失身份证、手机号码、邮箱缺失显示完善信息按钮 */}
                {userInfo?.nameEn && (
                  <>
                    {' '}
                    <Box my={2} color="#4b5563">
                      {t('tips.update_info', { field: SERVICE_PHONE_02 })}
                    </Box>
                    <Box mb={1}>
                      <InfoItem
                        label={t('common.English_name')}
                        fontSize={isMobile ? 14 : 16}
                        value={
                          <Box fontSize={isMobile ? 14 : 16} component="span">
                            {userInfo?.nameEn}
                          </Box>
                        }
                      />
                      {userInfo?.nameCn && (
                        <InfoItem
                          label={t('common.chinese_name')}
                          fontSize={isMobile ? 14 : 16}
                          value={
                            <Box fontSize={isMobile ? 14 : 16} component="span">
                              {userInfo?.nameCn}
                            </Box>
                          }
                        />
                      )}
                      <InfoItem
                        label={t('common.id_type')}
                        fontSize={!isMobile && 16}
                        value={t(ID_TYPES[userInfo?.identifyType].label)}
                      />
                      <InfoItem
                        label={t('common.id_type_number')}
                        fontSize={isMobile ? 14 : 16}
                        value={encryptId(userInfo?.identifyId, userInfo?.identifyType)}
                      />
                      <InfoItem
                        label={t('form.gender')}
                        fontSize={isMobile ? 14 : 16}
                        value={userInfo?.gender === '0' ? t('form.male') : t('form.female')}
                      />

                      <InfoItem
                        fontSize={isMobile ? 14 : 16}
                        label={t('form.birthday')}
                        value={userInfo?.birthday}
                      />
                      {/* <InfoItem
                label={t('form.mobile_phone')}
                value={formatDialingCode(userInfo?.dialingCode) + encryptPhone(userInfo?.phone)}
              /> */}
                      {/* <InfoItem label={t('form.email')} value={encryptEmail(userInfo?.email)} /> */}
                    </Box>
                  </>
                )}

                <PersonInfo userInfo={userInfo} isFilled={userInfo?.isCompleteInfo} fromOrder />
              </InfoWrapper>
              <InfoWrapper titleVariant={isMobile ? 'h4' : 'h6'} title={t('glossary.test_requisition_form')}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={schema}
                  onSubmit={throttle(async (values) => {
                    if (
                      noAppointmentTimesStatus === 'pending' ||
                      addOrderStatus === 'pending' ||
                      payStatus === 'pending' ||
                      hadCreateOrder ||
                      !(userInfo?.isCompleteInfo && userInfo?.phone)
                    ) {
                      return
                    }
                    if (
                      (Number(selectedDoctor?.package) === 4 && userInfo?.gender === '1') ||
                      (Number(selectedDoctor?.package) === 5 && userInfo?.gender === '0')
                    ) {
                      toast.warning(t('toast.gender_error'))
                      return
                    }
                    // 重新检查是否有号源
                    const noAppointmentTimesRes = await dispatch(
                      getNoAppointmentTimes({
                        doctorId: selectedDoctor?.doctorId,
                        date: selectedDoctor?.appointmentDate,
                        testCenterId: selectedDoctor?.testCenterId,
                      }),
                    )
                    const noAppointmentTimesPayload = unwrapResult(noAppointmentTimesRes)
                    // 号源被约满，toast提示后返回上一页
                    if (noAppointmentTimesPayload?.find((item) => item === selectedDoctor.appointmentTime)) {
                      return toast.warning(t('tips.can_not_booking'), {
                        onClose: () => {
                          history.push(`/${i18n.language}/clinic/${selectedDoctor.testCenterId}`)
                        },
                      })
                    }

                    const testFormAnswer = Object.values(values)?.join(',')
                    const orderRes = await dispatch(
                      addOrder({
                        appointmentDate: selectedDoctor.appointmentDate,
                        appointmentTime: selectedDoctor.appointmentTime,
                        doctorId: Number(selectedDoctor.doctorId),
                        doctorName: selectedDoctor?.[tB('name')],
                        doctorTitle: selectedDoctor[tB('honoraryTitle')],
                        testCenterId: selectedDoctor.testCenterId,
                        testCenterName: selectedDoctor[tB('testCenterName')],
                        testCenterPhone: selectedDoctor.testCenterPhone,
                        testCenterAddress: selectedDoctor?.[tB('testCenterAddress')],
                        testCenterAddressHk: selectedDoctor?.testCenterAddressHk,
                        testCenterAddressEn: selectedDoctor?.testCenterAddressEn,
                        testCenterAddressCn: selectedDoctor?.testCenterAddressCn,
                        price: selectedDoctor?.price,
                        currency: selectedDoctor?.currency,
                        package: Number(selectedDoctor?.package),
                        userName: userInfo.nameEn || userInfo.nameCn,
                        testFormAnswer,
                      }),
                    )
                    setHadCreateOrder(true)
                    const orderPayload = unwrapResult(orderRes)
                    if (selectedDoctor?.currency !== 'HKD') {
                      try {
                        // TagManager.dataLayer({
                        //   dataLayer: {
                        //     ecommerce: null,
                        //   },
                        // })
                        // TagManager.dataLayer({
                        //   dataLayer: {
                        //     event: 'checkout',
                        //     ecommerce: {
                        //       checkout: {
                        //         actionField: { step: 2 },
                        //         products: [
                        //           {
                        //             name: selectedDoctor[tB('name')] || '',
                        //             id: `${selectedDoctor.id || ''}`,
                        //             price: `${selectedDoctor.price || ''}`,
                        //             brand: selectedDoctor.testCenterName || '',
                        //             category: selectedDoctor[tB('honoraryTitle')] || '',
                        //             variant: selectedDoctor.appointmentTime || '',
                        //             dimension1: selectedDoctor.appointmentDate || '',
                        //             quantity: 1,
                        //           },
                        //         ],
                        //       },
                        //     },
                        //   },
                        // })
                        await dispatch(pay({ orderNumber: orderPayload?.orderNumber }))
                      } catch (error) {
                        toast.warning(t('toast.pay_fail'), {
                          onClose: () => {
                            history.replace(`/${i18n.language}/profile/order`)
                          },
                        })
                      }
                    } else {
                      addTrackingCode()
                      history.push(`/${i18n.language}/add-order/paying`, {
                        price: selectedDoctor.price,
                        currency: selectedDoctor.currency,
                        orderNumber: orderPayload.orderNumber,
                        packages: selectedDoctor?.package,
                      })
                    }
                  }, 1000)}
                >
                  {(props) => {
                    const { values, handleChange, handleSubmit, errors, touched, isSubmitting } = props
                    const isError = (field) => touched[field] && Boolean(errors[field])
                    const errorText = (field) =>
                      touched[field] &&
                      errors[field] && <FormHelperText>{touched[field] && errors[field]}</FormHelperText>

                    // const validateUserInfo = () => {
                    //   // 用户信息缺失身份证、手机号码、邮箱缺失显示提交错误
                    //   if (!userInfo?.birthday) {
                    //     // 页面滚动到用户信息 error helpText 处
                    //     toast.error(t('toast.please_enter_personal_info'))
                    //     setTimeout(() => {
                    //       scroller.scrollTo('userInfoErrorText', {
                    //         duration: 300,
                    //         smooth: true,
                    //         offset: -200,
                    //       })
                    //     }, 0)
                    //   }
                    // }

                    const handleCusSubmit = (e) => {
                      e.preventDefault()
                      if (userInfo?.isCompleteInfo) {
                        if (userInfo?.phone) {
                          return handleSubmit(e)
                        } else {
                          toast.error(t('tips.please_phone'))
                        }
                      } else {
                        const form = document.getElementById('form1')
                        if (form.checkValidity() === true) {
                          if (userInfo?.phone) {
                            return handleSubmit(e)
                          } else {
                            toast.error(t('tips.please_phone'))
                          }
                        }
                      }
                    }

                    return (
                      <form onSubmit={handleCusSubmit}>
                        <Typography component="div" color="primary">
                          <Box fontSize="body2.fontSize" color="grey.600" mb={4} component="span">
                            {t('tips.questions')}
                            <br />
                            <Trans i18nKey="tips.form_required">
                              .
                              <Box color="secondary.main" component="span">
                                *
                              </Box>
                              .
                            </Trans>
                          </Box>
                        </Typography>
                        {QUIZ_LIST.map((quiz, index) => (
                          <FormControl
                            margin="normal"
                            key={quiz.name}
                            fullWidth
                            error={isError(quiz.name)}
                            required
                          >
                            <InputLabel
                              disableAnimation
                              classes={{
                                formControl: classes.inputLabelFormControl,
                                asterisk: classes.asterisk,
                              }}
                            >
                              {t(quiz.question)}
                            </InputLabel>
                            <RadioGroup
                              className={classes.radioGroup}
                              row
                              name={quiz.name}
                              value={values?.[quiz.name]}
                              onChange={handleChange}
                            >
                              {(index === 3 ? QUIZ_ANSWER_OPTIONS.slice(0, 2) : QUIZ_ANSWER_OPTIONS)?.map(
                                (answer) => (
                                  <FormControlLabel
                                    key={answer.value}
                                    value={answer.value}
                                    control={<Radio size="small" color="secondary" />}
                                    label={t(answer.label)}
                                  />
                                ),
                              )}
                            </RadioGroup>
                            {errorText(quiz.name)}
                          </FormControl>
                        ))}
                        {isMobile ? (
                          <FixedButtonWrapper>{renderButton(isSubmitting)}</FixedButtonWrapper>
                        ) : (
                          renderButton(isSubmitting)
                        )}

                        {userInfo?.isCompleteInfo && userInfo?.phone && <FocusError />}
                      </form>
                    )
                  }}
                </Formik>
              </InfoWrapper>
            </Box>
            {!isMobile && (
              <Box ml={3} width="35%">
                {productAbstract()}
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  )
}

export default AddOrder
